import { useSearchParams } from "react-router-dom";

export function useUrlState<T extends Record<string, string | undefined>>() {
  const [searchParams, setSearchParams] = useSearchParams();

  const getSearchParam = (key: string) => {
    return searchParams.get(key) ?? undefined;
  };

  const getAllSearchParams = () => {
    const params: Record<string, string | undefined> = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params as T;
  }

  const setSearchParam = (key: string, value: string | undefined) => {
    if (value === undefined) {
      searchParams.delete(key);
    } else {
      searchParams.set(key, value);
    }
    setSearchParams(searchParams);
  };

  const setMultipleSearchParams = (params: Partial<T>) => {
    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined) {
        searchParams.delete(key);
      } else {
        searchParams.set(key, value);
      }
    });
    setSearchParams(searchParams);
  }

  return {
    getSearchParam,
    getAllSearchParams,
    setSearchParam,
    setMultipleSearchParams,
    searchParams,
  };
}